import script from "./EmpSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmpSettings.vue?vue&type=script&setup=true&lang=ts"

import "./EmpSettings.vue?vue&type=style&index=0&id=1ab4068a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab4068a"]])

export default __exports__